import { useBreakpoints } from "hooks/useBreakpoints"
import { Wrapper } from "components/Wrapper"
import { Section } from "components/Section"

export const ItemsSection = ({ title, color, items, viewMoreButton }) => {
  const { lg } = useBreakpoints()

  return (
    <Section color={color}>
      <Wrapper>
        <Section.Title>{title}</Section.Title>
      </Wrapper>
      {lg ? (
        <Wrapper>
          <div className="grid grid-cols-4 gap-4">{items}</div>
        </Wrapper>
      ) : (
        <div className="px-5 pb-2 flex space-x-6 overflow-x-auto">{items}</div>
      )}
      <Wrapper>
        <div className="flex flex-col pt-4 items-center">{viewMoreButton}</div>
      </Wrapper>
    </Section>
  )
}
